import { Shield, CheckCircle2, Lock, Globe, Plug } from "lucide-react";

const badges = [
  { icon: Shield, label: "ФЗ-347", description: "Полное соответствие" },
  { icon: CheckCircle2, label: "ФЗ-152", description: "Защита данных" },
  { icon: Lock, label: "РКН-Ready", description: "Готов к проверке" },
  { icon: Globe, label: "SOC 2", description: "Безопасность" },
];

const stats = [
  "1 200+ рекламодателей",
  "50 000+ erid-токенов",
  "0 штрафов у клиентов",
];

const ordPartners = [
  "VK ОРД",
  "Ozon ОРД",
];

export function TrustBar() {
  return (
    <section
      className="w-full max-w-6xl mx-auto mt-12 px-4 animate-fade-in"
      style={{ animationDelay: '1s', animationDuration: '0.6s', animationFillMode: 'backwards' }}
    >
      <div className="glass-card px-6 py-5">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          {/* Badges */}
          <div className="flex flex-wrap items-center gap-3">
            {badges.map((b, i) => (
              <div
                key={b.label}
                className="flex items-center gap-2 rounded-xl border border-border/40 bg-secondary/30 px-3 py-2 animate-scale-in"
                style={{ animationDelay: `${1.1 + i * 0.08}s`, animationFillMode: 'backwards' }}
              >
                <b.icon className="h-3.5 w-3.5 text-success" />
                <div>
                  <p className="text-[10px] font-bold text-foreground leading-none">{b.label}</p>
                  <p className="text-[8px] text-muted-foreground">{b.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center gap-4">
            {stats.map((stat) => (
              <div key={stat} className="flex items-center gap-1.5 text-xs text-muted-foreground">
                <CheckCircle2 className="h-3.5 w-3.5 text-success shrink-0" />
                <span>{stat}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ORD partners row */}
        <div className="mt-5 border-t border-border/30 pt-4">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
            <div className="flex items-center gap-2 shrink-0">
              <Plug className="h-3.5 w-3.5 text-primary" />
              <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
                Интеграции с ОРД
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {ordPartners.map((p, i) => (
                <span
                  key={p}
                  className="inline-flex items-center rounded-lg border border-border/40 bg-background/40 px-2.5 py-1 text-[10px] font-medium text-foreground/80 animate-scale-in"
                  style={{ animationDelay: `${1.4 + i * 0.06}s`, animationFillMode: 'backwards' }}
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
